import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './StatBlock.module.scss';
import clsx from 'clsx';
import Block from '../Block/Block';
import EmptyText from '../EmptyText/EmptyText';
const StatBlock = ({ title, icon, color, list, reverse }) => {
  return (
    <>
      <Block title={title}>
        <div className={clsx(styles.list)}>
          {!list?.length ? (
            <EmptyText fontSize={16}>Список пуст</EmptyText>
          ) : (
            list?.map((item) => (
              <div className={clsx(styles.item)}>
                {item?.icon && <div className={clsx(styles.icon)}>{item?.icon}</div>}
                {reverse ? (
                  <>
                    {' '}
                    <div className={clsx(styles.value)}>{item?.label}</div>
                    <div className={clsx(styles.label)}>{item?.value}</div>
                  </>
                ) : (
                  <>
                    {' '}
                    <div className={clsx(styles.label)}>{item?.label}</div>
                    <div className={clsx(styles.value)}>{item?.value}</div>
                  </>
                )}
              </div>
            ))
          )}
        </div>
        <div className={clsx(styles.blockIcon)} style={{ background: color }}>
          {icon}
        </div>
      </Block>
    </>
  );
};

export default StatBlock;
